function unhide(element) {
  $(element).find('.js-bookmark-icon').removeClass('dc-bookmark-icon--hidden')
}

function hide(element) {
  $(element).find('.js-bookmark-icon').addClass('dc-bookmark-icon--hidden')
}

function hoverState(element){
  element
  .on('mouseover', '.js-course-bookmarking', function(){
    unhide(this);
  })
  .on('mouseleave', '.js-course-bookmarking', function(){
    hide(this);
  });
}

function clickCreate(element){
  element
  .on('click', '.js-bookmark-icon-click-destroy', function(){
    $(this).removeClass('dc-bookmark-icon--bookmarked');
    $(this).addClass('dc-bookmark-icon--bookmark');
    $(this).removeClass('dc-bookmark-icon--hidden');
    $('.tooltip').hide()
    element.on('mouseleave', '.js-course-bookmarking', function(){
      hide(this);
    });
  })
}

function clickDestroy(element){
  element
  .on('click', '.js-bookmark-icon-click-create', function(){
    $(this).removeClass('dc-bookmark-icon--bookmark');
    $(this).addClass('dc-bookmark-icon--bookmarked');
    $(this).removeClass('dc-bookmark-icon--hidden');
    $('.tooltip').hide()
    element.off('mouseleave');
  })
}

hoverState($(".js-async-bookmarking"));
clickCreate($(".js-async-bookmarking"));
clickDestroy($(".js-async-bookmarking"));
